export default __webpack_public_path__ + "static/media/present-a-new-business-idea.d02c4e35.pdf";